const footerStyles = `
  :root {
    --g2: #3d6622;
  }

  /* ── FOOTER ── */
  .footer-main {
    max-width: 1200px; margin: 0 auto;
    display: grid; grid-template-columns: 2fr 1fr 1fr 1fr;
    gap: 48px; padding: 56px 72px 36px;
  }
  .ft-brand { font-family: 'Sora', sans-serif; font-size: 18px; font-weight: 800; margin-bottom: 12px; color: #111; }
  .ft-tag { font-size: 14px; color: #9ca3af; line-height: 1.65; max-width: 220px; }
  .ft-col-h { font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: 1px; color: #9ca3af; margin-bottom: 16px; }
  .ft-links { list-style: none; display: flex; flex-direction: column; gap: 11px; }
  .ft-links a { font-size: 15px; color: #4b5563; text-decoration: none; font-weight: 400; }
  .ft-links a:hover { color: var(--g2); }
  .ft-social { display: flex; gap: 10px; margin-top: 6px; }
  .soc {
    width: 34px; height: 34px; border-radius: 50%;
    background: #f3f4f6; display: flex; align-items: center; justify-content: center;
    font-size: 14px; color: #555; text-decoration: none;
  }
  .footer-bottom {
    border-top: 1px solid #f0f0f0; padding: 20px 72px;
    font-size: 13px; color: #c4c9d4; text-align: center;
  }
`;

export default function Footer() {
  return (
    <>
      <style>{footerStyles}</style>
      <div className="footer-main">
        <div>
          <div className="ft-brand">imTransporter</div>
          <div className="ft-tag">Scaling the world's enterprise transportation with technology and trust.</div>
        </div>
        <div>
          <div className="ft-col-h">Company</div>
          <ul className="ft-links">
            {["About Us", "Pricing", "Careers"].map(l => (
              <li key={l}><a href="#">{l}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <div className="ft-col-h">Platform</div>
          <ul className="ft-links">
            {["Driver Login", "API Docs"].map(l => (
              <li key={l}><a href="#">{l}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <div className="ft-col-h">Follow Us</div>
          <div className="ft-social">
            <a href="#" className="soc">𝕏</a>
            <a href="#" className="soc">in</a>
            <a href="#" className="soc">▶</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} imTransporter — Logistics. All rights reserved.
      </div>
    </>
  );
}